module.exports = __webpack_public_path__ + "img/23F9.49b07e89.svg";